import { render } from "./OrdersTable.vue?vue&type=template&id=788c83a8"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=788c83a8&lang=scss"
import "./OrdersTable.vue?vue&type=style&index=1&id=788c83a8&scope=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__